var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-container-fluid"},[_vm._v(" "+_vm._s(_vm.$t('message.logout'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }